import { convertDistanceUnit, formatDecimalHoursWithDays } from '@/utils/helpers';
import { CalculatorResponseDtoSchemaType } from 'components/forms/CarrierFormFactory/types';
import { DistanceUnit, formatMoney } from 'remote/global';
import { PricingDetails } from 'utils/data/data-types';

const getAttributesTableData = (
  pricingDetails: PricingDetails,
  language: string,
  distanceUnit: DistanceUnit
) => {
  const getTotalTime = () => {
    const { days, hours } = pricingDetails;
    return formatDecimalHoursWithDays(hours, days, language);
  };

  return [
    {
      label: distanceUnit === DistanceUnit.MI ? 'totalMileageMi' : 'totalMileageKm',
      value: convertDistanceUnit(pricingDetails.mileageKm, DistanceUnit.KM, distanceUnit).toFixed(
        0
      ),
    },
    {
      label: 'totalTime',
      value: getTotalTime(),
    },
  ];
};

const getCostsFirstTableData = (
  pricingDetails: CalculatorResponseDtoSchemaType,
  currency: string,
  language?: string
) => {
  return [
    {
      label: 'fuel',
      value: formatMoney(pricingDetails.costs.fuelCost, currency, language),
    },
    {
      label: 'vehicle',
      value: formatMoney(
        pricingDetails.costs.vehicleTimeCost + pricingDetails.costs.vehicleMileageCost,
        currency,
        language
      ),
    },
    {
      label: 'driver',
      value: formatMoney(pricingDetails.costs.driversCost, currency, language),
    },
    {
      label: 'admin',
      value: formatMoney(pricingDetails.costs.adminCost, currency, language),
    },
    {
      label: 'departure',
      value: formatMoney(pricingDetails.costs.departureCost, currency, language),
    },
    {
      label: 'sumOfTotalCosts',
      value: formatMoney(pricingDetails.sumOfTotalCosts, currency, language),
    },
  ];
};

const getCostsSecondTableData = (
  pricingDetails: CalculatorResponseDtoSchemaType,
  getAdjustmentValue: () => number | null,
  currency: string,
  language?: string
) => {
  return [
    {
      label: 'priceExclVat',
      value: formatMoney(pricingDetails.finalPriceExclVat, currency, language),
    },
    {
      label: 'priceInclVat',
      value: formatMoney(pricingDetails.finalPriceInclVat, currency, language),
    },
    {
      label: 'discountApplied',
      value:
        pricingDetails.adjustmentType === 'DISCOUNT'
          ? formatMoney(getAdjustmentValue() || 0, currency, language)
          : '',
    },
    {
      label: 'markupApplied',
      value:
        pricingDetails.adjustmentType === 'MARKUP'
          ? formatMoney(getAdjustmentValue() || 0, currency, language)
          : '',
    },
    {
      label: 'netProfit',
      value: `${pricingDetails.netProfitMargin}%`,
    },
  ];
};

export { getAttributesTableData, getCostsFirstTableData, getCostsSecondTableData };
